(function (Drupal, $, once) {
  Drupal.behaviors.tables = {
    attach: function (context) {
      $(function () {
        //table horizontal scroll
        $(once('tables-once', "table"))
          .each(function () {
            var $this = $(this);
            var wrapper1 = $this.parent();
            if (!wrapper1.hasClass("table-wrapper")) {
              $this.wrap('<div class="table-wrapper"></div>');
            }
          });
      });
    },
  };
}(Drupal, jQuery, once));
